<template>
  
  <div class="flex flex-column pl-2 pr-2">

      <div class="mt-2 mb-2 flex align-items-center flex-column md:justify-content-between md:flex-row">
        <h2 class="">KUSY</h2>
        <div class="flex align-items-center">
            <router-link to="/mod-stock/stock-items/0" class="mr-2">
              <PrimevueButton label="Pridať kus" severity="success" icon="pi pi-plus" text raised class="uppercase"/>
            </router-link>
            <router-link to="/mod-stock/bulk-add-items" class="mr-2">
              <PrimevueButton label="Pridanie kusov" severity="success" icon="pi pi-plus" text raised class="uppercase"/>
            </router-link>
            <router-link to="/mod-stock/scan-item" class="mr-2">
              <PrimevueButton label="Skenovať kus" severity="success" icon="pi pi-camera" text raised class="uppercase"/>
            </router-link>
        </div>
      </div>
      <DataTable
          
          lazy paginator :rows="this.pagination.rows"
          @page="onPage"
          :first="this.pagination.first"
          :loading="loading"
          :totalRecords="this.pagination.totalRecords"
          dataKey="id"
          :value="this.stockItems"
          v-model:filters="filters"
          @filter="onFilter"
          filterDisplay="row" 
          :globalFilterFields="globalFilterFields"
          stripedRows
          row-hover
          scrollable
          v-model:selection="this.selectedStockItem"
          selectionMode="single"
          :metaKeySelection="false"
          @rowSelect="showDetail(this.selectedStockItem.id)"
          tableStyle="min-width: 50rem"
          :virtualScrollerOptions="{ itemSize: 100 }"
          :scrollHeight="`${this.vh - 420}px`"
      >
        <template #header>
          <div class="flex grid">
            <div class="field grid col-12 md:col-6">
              <label for="item-category" class="col-12 md:col-2 md:mb-0">Kategória</label>
              <div class="col-12 md:col-10 flex align-items-center justify-content-between gap-1" >
                <PrimevueSelect
                    id="item-category"
                    v-model="this.selectedCategory"
                    :options="this.categories"
                    optionLabel="name"
                    placeholder="Výberom kategórie sa zobrazí tabuľka produktov"
                    class="w-full"

                    @change="filterProducts(this.selectedCategory.id)"
                >
                  <template #value="slotProps">
                    <div v-if="slotProps.value" class="">
                        <div>{{ slotProps.value.name }}</div>
                    </div>
                    <span v-else>
                      {{ slotProps.placeholder }}
                    </span>
                  </template>
                  <template #option="slotProps">
                      <div class="">
                        <div>{{ slotProps.option.name }}</div>
                      </div>
                  </template>
                </PrimevueSelect>  
                <PrimevueButton v-if="this.selectedCategory" type="button" v-tooltip.top="{ value: 'Zrušenie výberu' }" class=""
                  icon="pi pi-filter-slash" @click="cancelSelect()" text 
                />
              </div> 
            </div>
            
            <div class="field grid col-12 md:col-6 ">
              <div class="col-12 flex justify-content-end">
                <IconField iconPosition="left" class="">
                  <InputIcon>
                    <i class="pi pi-search mr-2"/>
                  </InputIcon>
                  <InputText v-model="filters['global'].value" placeholder="Vyhľadať" @keydown.enter="onFilter"/>
                </IconField>
              </div>
            </div>
          </div>
        </template>

        <Column header="">
          <template #body="slotProps">
              <img :src="`${slotProps.data.product.image}`" :alt="slotProps.data.product.image" class="shadow-4 border-round" width="64" />
          </template>
        </Column>

        <Column header="" style="min-width: 5%">
          <template #body="slotProps">
            <div
              class="color-box"
              :style="{ backgroundColor: slotProps.data.color.colorHash }"
            ></div>
          </template>
        </Column>

        <Column field="code" header="Kód"
                filterField="productNumber"
                :showFilterMenu="false"
                :filterMenuStyle="{ width: '6rem' }" style="min-width: 10%">
          <template #body="slotProps">
            {{ slotProps.data.code }}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter"
                       placeholder="Hľadať" style="min-width: 5rem"/>
          </template>
        </Column>
        
        <Column field="product.category.name" header="Kategória"
                filterField="categoryName"
                :showFilterMenu="false" :filterMenuStyle="{ width: '6rem' }" style="min-width: 10%"
                >
          <template #body="slotProps">
             {{ slotProps.data.product.category.name }}
          </template>
          
          <template #filter="{ filterModel, filterCallback }">
            <PrimevueSelect v-model="filterModel.value" @change="filterCallback()"
                      :options="this.categories" optionLabel="name" placeholder="Vyber kategóriu"
                      class="p-column-filter" style="min-width: 6rem" >
              <template #option="slotProps">
                {{slotProps.option.name}}
              </template>
            </PrimevueSelect>
          </template>
        </Column>

        <Column field="product.name" header="Názov"
                filterField="productName"
                :showFilterMenu="false"
                :filterMenuStyle="{ width: '6rem' }" style="min-width: 10%">
          <template #body="slotProps">
            {{ slotProps.data.product.name }}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter"
                       placeholder="Hľadať" style="min-width: 6rem"/>
          </template>
        </Column>
 
        <Column field="length" header="Dĺžka"
                filterField="productLength"
                :showFilterMenu="false"
                :filterMenuStyle="{ width: '4rem' }" style="min-width: 5%">
          <template #body="slotProps">
            {{ slotProps.data.length }}
          </template>
          <!--
          <template #filter="{ filterModel, filterCallback }">
            <InputNumber v-model="filterModel.value" :useGrouping="false" fluid @keydown.enter="filterCallback()" class="p-column-filter"
                       placeholder="Hľadať" style="min-width: 4rem"/>
          </template>
          -->
        </Column>

        <Column field="comment" header="Poznámka"
                filterField="comment"
                :showFilterMenu="false"
                :filterMenuStyle="{ width: '5rem' }" style="min-width: 10%">
          <template #body="slotProps">
            {{ slotProps.data.comment }}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter"
                       placeholder="Hľadať" style="min-width: 6rem"/>
          </template>
        </Column>

        <Column field="location" header="Umiestnenie"
                filterField="location"
                :showFilterMenu="false"
                :filterMenuStyle="{ width: '5rem' }" style="min-width: 10%">
          <template #body="slotProps">
            {{ slotProps.data.location }}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter"
                       placeholder="Hľadať" style="min-width: 6rem"/>
          </template>
        </Column>

        <Column field="color.code" header="Farba"
                filterField="color"
                :showFilterMenu="false"
                :filterMenuStyle="{ width: '5rem' }" style="min-width: 10%">
          <template #body="slotProps">
            {{ slotProps.data.color ? slotProps.data.color.code : ""}}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter"
                       placeholder="Hľadať" style="min-width: 6rem"/>
          </template>
        </Column>

        <Column field="" header="Objednávka"
                filterField="orderCode"
                :showFilterMenu="false"
                :filterMenuStyle="{ width: '4rem' }" style="min-width: 10%">
          <template #body="slotProps">
            {{ slotProps.data.order ? slotProps.data.order.orderCode : ""}}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter"
                       placeholder="Hľadať" style="min-width: 4rem"/>
          </template>
        </Column>

        <Column field="order.customerLastName" header="Zákazník"
                filterField="customer"
                :showFilterMenu="false"
                :filterMenuStyle="{ width: '6rem' }" style="min-width: 10%">
          <template #body="slotProps">
            {{ slotProps.data.order ? slotProps.data.order.customerLastName : ""}}
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <InputText v-model="filterModel.value" type="text" @keydown.enter="filterCallback()" class="p-column-filter"
                       placeholder="Hľadať" style="min-width: 6rem"/>
          </template>
        </Column>

        <Column header="">
          <template #body="slotProps">

            <PrimevueButton type="button" v-tooltip.top="{ value: 'Vymazanie produktu' }" icon="pi pi-trash" @click="confirmDelete(slotProps.data.id)" text severity="danger" size="small"/>

          </template>
        </Column>
      </DataTable>

      <PrimevueDialog v-model:visible="this.visibleProducts" header="Produkty" :style="{ width: '60rem' }"> 
        <div class="grid">
          <div v-for="(prod,index) in this.products" v-bind:key="index" class="p-1 sm:col-12 md:col-4 lg:col-4 xl:col-4">
              <PrimevueButton outlined 
                class="p-1"  @click="setSelectProduct(prod) "
                @mouseover="this.hoverIndex = index"
                @mouseleave="this.hoverIndex = null"
                :style="buttonStyle(index)"   
                >
                <div class="grid w-full h-full">
                  <div class="col-6 p-2">
                    <div class="text-left font-bold">{{ prod.code }}</div>
                    <div class="text-left mt-5">{{ prod.name }}</div>
                  </div>
                  <div class="col-6 p-1 flex justify-content-center">
                    <div class="w-full h-full flex justify-content-center align-items-center">
                      <img :src="prod.image" 
                          :style="`${prod.imageHeight >= prod.imageWidth ? 'height:168px;' : 'width:140px;'}`"
                          @load="checkImageSize(index,$event)"
                          alt="Preview Image" class=""/>
                    </div>
                  </div>
                </div> 
              </PrimevueButton>
          </div>
        </div>  
      </PrimevueDialog>

  </div>
  <ConfirmDialog></ConfirmDialog>

</template>

<script lang="ts">

import IconField from 'primevue/iconfield';
import {store} from "@/components/store";
import Security from "@/components/security";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import router from "@/router";
import {FilterMatchMode} from "primevue/api";
import PrimevueSelect from "primevue/dropdown";
import InputIcon from "primevue/inputicon";
import notie from "notie/dist/notie";
import PrimevueButton from "primevue/button";
import PrimevueDialog from 'primevue/dialog';
//import Utils from '@/components/utils';
//import {emiter} from '../main';

export default {
  components: {
    DataTable,
    Column,
    IconField,
    PrimevueSelect,
    InputIcon,
    PrimevueButton,
    PrimevueDialog

  },
  name: "StockItemList",
  data() {
    return {
      store,
      hoverIndex: null,
      visibleProducts: false,
      vh: 0,
      selectedStockItem: null,
      stockItems: [],
      filters: {
        global: {value: null, matchMode: FilterMatchMode.CONTAINS},
        productNumber: {value: null, matchMode: FilterMatchMode.CONTAINS},
        productName: {value: null, matchMode: FilterMatchMode.CONTAINS},
        comment: {value: null, matchMode: FilterMatchMode.CONTAINS},
        location: {value: null, matchMode: FilterMatchMode.CONTAINS},
        orderCode: {value: null, matchMode: FilterMatchMode.CONTAINS},
        customer: {value: null, matchMode: FilterMatchMode.CONTAINS},        
        color: {value: null, matchMode: FilterMatchMode.CONTAINS},
        categoryName: {value: null, matchMode: FilterMatchMode.CONTAINS},
        //productLength: {value: null, matchMode: FilterMatchMode.EQUALS},
      },
      filterFields: [  {field: 'Code',value: ""},
                       {field: 'Product__CategoryId__Name',value: ""},
                       {field: 'Product__Name',value: ""},
                       {field: 'Comment',value: ""},   
                       {field: 'Location',value: ""},    
                       {field: 'Order__OrderCode',value: ""}, 
                       {field: 'Order__CustomerLastname',value: ""},                  
                       {field: 'Color__Code',value: ""},
                       //{field: 'Length',value: ""}
                    ],
      globalFilterFields: ['Code', 'Product__Name', 'Order__OrderCode','Order__CustomerLastname','Product__CategoryId__Name','Color__Code'],
      categories: [],
      products: [],
      loading: true,
      selectedCategory: null,
      pagination: {
        first: 0,
        rows: 100,
        totalRecords: 0, // Total number of records for pagination
        filters: {},
      },
    }
  },
  beforeMount() {
    if (Security.requireToken()){
      store.selectModul = this.$route.path.split("/")[1]
      this.setDynamicHeight(); 
      // Aktualizácia výšky pri zmene veľkosti okna
      window.addEventListener("resize", this.setDynamicHeight);
      
      this.initFilters()

      //if (store.user.admin) {
      //  this.globalFilterFields = ['productCode', 'ModifiedUser__LastName','CustomerId__Company', 'CustomerLastName', 'CurrentState__Name']
      //}
      
      fetch(store.Api_url + "/v1/category?query=deleted:0", Security.requestOptions("GET"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
                notie.alert({
                      type: 'error',
                      text: "Zoznam kategórií sa nepodarilo načítať: " + responseData.message,
                      position: "top"
                    })           
            } else {
              //console.log(responseData);
              this.categories = responseData.data

              this.loading = false
            }
          })
          .catch((error) => {
            notie.alert({
                      type: 'error',
                      text: "Zoznam kategórií sa nepodarilo načítať: " + error,
                      position: "top"
                    })           
      });
      
      this.loadComponent()
    }
  },
  
  beforeUnmount() {

    window.removeEventListener("resize", this.setDynamicHeight);
  },

  methods: {

    checkImageSize(index,event) {
      this.products[index].imageWidth = event.target.naturalWidth;
      this.products[index].imageHeight = event.target.naturalHeight;
    },

    setSelectProduct(product){
      
      this.visibleProducts = false
      this.pagination.filters.filterFields = [ {field: 'Code',value: product.code},
                                              {field: 'Product__Name',value: ""},
                                              {field: 'Product__CategoryId__Name',value: ""},
                                              {field: 'Comment',value: ""},
                                              {field: 'Location',value: ""},
                                              {field: 'Order__OrderCode',value: ""},
                                              {field: 'Order__CustomerLastname',value: ""},
                                              {field: 'Color__Code',value: ""},
                                              //{field: 'Length',value: event.filters.productLength.value ? event.filters.productLength.value : ""}
                                            ];
        this.pagination.filters.globalFilterFields = this.globalFilterFields;
        this.pagination.first = 0;  // Reset to the first page
        this.pagination.filters.global = this.filters.global.value
        this.loadLazyData(this.store.basicUrlFilterStockItems,this.pagination);                                       
    },

    cancelSelect(){
      this.selectedCategory = null
      this.initFilters()
      this.loadComponent()
    },

    buttonStyle(index) {
      return {
        height: '172px',
        width: '295px',
        borderWidth: this.hoverIndex === index ? '2px' : '1px',
        borderColor: this.hoverIndex === index ? '#0000FF' : '#ccc', // Farba okraja
        transition: 'border-width 0.2s ease-in-out,border-color 0.2s ease-in-out'
      };
    },

    filterProducts(categoryId:number){
      fetch(this.store.Api_url + "/v1/product?query=deleted:0,category_id:"+categoryId, Security.requestOptions("GET"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
             
              notie.alert({
                type: 'error',
                text: "Zoznam produktov sa nepodarilo načítať"
              })
            } else {
              
              if (responseData.data){
                this.products = responseData.data
                this.visibleProducts = true
              }else{
                this.products =[]
              }
            }
          })
          .catch((error) => {
            this.$emit('error', "Chyba pri načítaní produktov" + error);
      })
    },

    setDynamicHeight() {
      this.vh = window.innerHeight; // Nastavenie viditeľnej výšky
    },
 
    showDetail(productId:number) {
      router.push('/mod-stock/stock-items/' + String(productId))
    },

    confirmDelete(productId:number) {
      this.$confirm.require({
          message: 'Naozaj chcete vymazať kus?',
          header: 'Vymazanie kusu',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: "Áno",
          rejectLabel: "Nie",

          accept: () => {
            this.deleteproduct(productId)
          },

      });
    },

    deleteproduct(stockItemId:number){
      //if(confirm("Naozaj chcete ODSTRÁNIŤ objednávku?")){
        Security.requireToken();
        fetch(store.Api_url + "/v1/stock-item/" + String(stockItemId), Security.requestOptions("DELETE"))
            .then((response) => response.json())
            .then((responseData) => {
              if (responseData.error) {
                //console.log("error:", responseData.message);
                this.$emit('error', responseData.message);
                notie.alert({
                    type: 'error',
                    text: "Kus sa nepodarilo odstrániť: " + responseData.message,
                    position: "top"
                  })           
              } else {

                //this.stockItems = responseData.data;
                notie.alert({
                  type: 'success',
                  text: "Kus bol odstránený",
                  position: "bottom"
                })
                this.initFilters()
                this.loadComponent()
              }
            })
            .catch((error) => {
              alert('Chyba pri odstránení kusu: ' + error)
            })
      //}
    },

    onPage(event) {
        this.pagination.first = event.first; // PrimeVue page is zero-based; adjust if your API is 1-based

        this.loadLazyData(this.store.basicUrlFilterStockItems,this.pagination);
    },
  
    loadComponent(){

      this.pagination.first = 0
      this.pagination.totalRecords = 0

      this.loadLazyData(this.store.basicUrlFilterStockItems,this.pagination)

    },
    initFilters(){
        this.pagination.filters.filterFields = this.filterFields
        this.pagination.filters.global = ""
        this.pagination.filters.table = "stock_item"
        this.pagination.filters.globalFilterFields = this.globalFilterFields;

    },
    onFilter(event) {
        if(event.filters){
          //console.log("Event:", event);
           this.pagination.filters.filterFields = [ {field: 'Code',value: event.filters.productNumber.value ? event.filters.productNumber.value : ""},
                                                    {field: 'Product__Name',value: event.filters.productName.value ? event.filters.productName.value: ""},
                                                    {field: 'Product__CategoryId__Name',value: event.filters.categoryName.value ? event.filters.categoryName.value["name"]: ""},
                                                    {field: 'Comment',value: event.filters.comment.value ? event.filters.comment.value: ""},
                                                    {field: 'Location',value: event.filters.location.value ? event.filters.location.value: ""},
                                                    {field: 'Order__OrderCode',value: event.filters.orderCode.value ? event.filters.orderCode.value: ""},
                                                    {field: 'Order__CustomerLastname',value: event.filters.customer.value ? event.filters.customer.value: ""},
                                                    {field: 'Color__Code',value: event.filters.color.value ? event.filters.color.value: ""},
                                                    //{field: 'Length',value: event.filters.productLength.value ? event.filters.productLength.value : ""}
                                                  ];
           this.pagination.filters.global = event.filters.global.value                                        
        }else{
          this.pagination.filters.filterFields = this.filterFields
          this.pagination.filters.global = this.filters.global.value
          //console.log("Filters:", this.pagination.filters);
        }
        this.pagination.filters.globalFilterFields = this.globalFilterFields;
        this.pagination.first = 0;  // Reset to the first page
        //console.log("Filters:", this.pagination.filters);
        this.loadLazyData(this.store.basicUrlFilterStockItems,this.pagination);
    },
    
    loadLazyData(route,params) {
      this.loading = true;

      let queryParams = `&limit=${params.rows}&offset=${(params.first)}`;

      fetch(`${store.Api_url}${route}${queryParams}`, Security.requestOptions("POST",params.filters))
          .then(response => response.json())
          .then(responseData => {
            if (responseData.error) {
              //console.error("error:", responseData.message);
              //this.$emit('error', responseData.message);
              notie.alert({
                    type: 'error',
                    text: "Zoznam kusov sa nepodarilo načítať " + responseData.message,
                    position: "top"
                  })           
            } else {
              if(responseData.data){
                  this.stockItems = responseData.data;
 
                }else{
                    notie.alert({
                    type: 'info',
                    text: "Zoznam kusov je prázdny",
                    position: "top"
                  })
                  this.stockItems = []
                }
              this.pagination.totalRecords = responseData.totalRecords;
              this.loading = false;
            }
          })
          .catch(error => {
            //alert('Error fetching data: ' + error);
            notie.alert({
                    type: 'error',
                    text: "Chyba pri načítaní kusov: "+error,
                    position: "top"
                  })
            this.loading = false;
          });
    }
  }

}
</script>

<style>


</style>